'use client';
import { CosImage, SpanCounter, Image, StaticImport } from '@ssv-website/web-ui';

interface IImgBoxProps {
  className?: string;
  src: string | StaticImport;
  path?: string;
  title: string;
  children?: React.ReactNode;
  count: string;
  text: string;
  count_sec?: string;
  text_sec?: string;
  width?: number;
  height?: number;
  link?: string;
}
const ImgBox = (props: IImgBoxProps) => {
  const {
    src,
    path,
    className,
    title,
    text,
    count,
    count_sec,
    text_sec,
    width,
    height,
    link,
  } = props;
  const { num, unit } = getNumAndUnit(count);
  const processedText = text?.replace(/\n/g, '<br/>');

  const { num: num_sec, unit: unit_sec } = getNumAndUnit(count_sec ?? '');
  const processedText_sec = text_sec?.replace(/\n/g, '<br/>') ?? '';
  const onLink = () => {
    if(!link) return;
    window.location.href = link ?? '/';
  };
  return (
    <div
      className={`${className} group  w-full h-full rounded-md overflow-hidden relative flex items-end ${link ? 'cursor-pointer': ''}`}
      onClick={onLink}
    >
      {path ? (
        <CosImage
          path={path}
          alt=""
          className={`object-cover w-full h-full ${
            link ? 'group-hover:scale-125' : ''
          } transition-all duration-700 absolute left-0 top-0 -z-10`}
          width={width ?? 900}
          height={height ?? 450}
          quality={90}
        />
      ) : (
        <Image
          src={src}
          alt=""
          className={`object-cover w-full h-full ${
            link ? 'group-hover:scale-125' : ''
          } transition-all duration-700 absolute left-0 top-0 -z-10`}
          width={width ?? 900}
          height={height ?? 450}
          quality={90}
        />
      )}
      <div className="p-5 text-white">
        <div className="text-xl font-600">{title}</div>
        <Count num={num} unit={unit} />
        <Text text={processedText} />
        {count_sec && <Count num={num_sec} unit={unit_sec} />}
        {text_sec && <Text text={processedText_sec} />}
      </div>
    </div>
  );
};

export default ImgBox;

export const getNumAndUnit = (value: string) => {
  const normalizedValue = value?.toString().trim() ?? '';
  const match = normalizedValue.match(/^(\d+(?:\.\d+)?)(.*)$/);

  if (!match) {
    return { num: 0, unit: normalizedValue };
  }

  const num = Number(match[1]);
  const unit = match[2]?.trim() ?? '';
  return { num, unit };
};

const Count = ({ num, unit }: { num: number; unit: string }) => (
  <div className="my-1">
    <SpanCounter className="text-[4rem] font-300" value={num} />
    <span className="text-[4rem] font-300">{unit}</span>
  </div>
);
const Text = ({ text }: { text: string }) => (
  <div
    className="text-base font-300"
    dangerouslySetInnerHTML={{ __html: text }}
  />
);
